import FolderManagementModal from '../folder-management-modal';
import {
  useGetClosetsQuery,
  useCreateClosetMutation,
  useAddItemsToClosetMutation,
  useRemoveItemsFromClosetMutation,
  useUpdateClosetMutation
} from '../../redux/apis/endpoints/closetApi';

/**
 * Wrapper component for managing clothing items in closet folders.
 * Uses the shared FolderManagementModal component.
 */
const AddToClosetModal = ({ open, onClose, selectedItemIds = [], onSuccess }) => {
  const { data: closets = [], isLoading } = useGetClosetsQuery(undefined, { skip: !open });
  const [createCloset] = useCreateClosetMutation();
  const [updateCloset] = useUpdateClosetMutation();
  const [addItemsToCloset] = useAddItemsToClosetMutation();
  const [removeItemsFromCloset] = useRemoveItemsFromClosetMutation();

  // Transform closets to folder format for FolderManagementModal
  const folders = closets.map(closet => ({
    id: closet.id,
    name: closet.name,
    isDefault: closet.isDefault,
    itemCount: closet.itemCount || 0,
    previewImage: closet.previewImages?.[0] || null,
    itemIds: (closet.closet_clothes || []).map(item => item.id)
  }));

  // Callback handlers
  const handleCreateFolder = async (name) => {
    return createCloset(name).unwrap();
  };

  const handleUpdateFolder = async (id, name) => {
    return updateCloset({ id, name }).unwrap();
  };

  const handleAddItems = async (folderId, itemIds) => {
    return addItemsToCloset({ closetId: folderId, itemIds }).unwrap();
  };

  const handleRemoveItems = async (folderId, itemIds) => {
    return removeItemsFromCloset({ closetId: folderId, itemIds }).unwrap();
  };

  return (
    <FolderManagementModal
      open={open}
      onClose={onClose}
      folders={folders}
      selectedItemIds={selectedItemIds}
      isLoading={isLoading}
      onCreateFolder={handleCreateFolder}
      onUpdateFolder={handleUpdateFolder}
      onAddItems={handleAddItems}
      onRemoveItems={handleRemoveItems}
      onSuccess={onSuccess}
      title="Manage Closets"
      folderIcon="folder open"
      itemLabel="closet"
      createPlaceholder="New closet name..."
    />
  );
};

export default AddToClosetModal;
